import {Button, Paper} from '@material-ui/core';
import analytics, { changeAnalyticsState } from 'Core/ducks/analytics';
import {Async, Loaded} from 'Core/models/Async';
import {eqPhoneNumber, PhoneNumber, ValidPhoneNumber} from 'Core/models/PhoneNumber';
import {Either, fold, isRight, left, right} from 'fp-ts/lib/Either';
import {identity} from 'fp-ts/lib/function';
import {pipe} from 'fp-ts/lib/pipeable';
import React, {useState} from 'react';
import {ReducerState} from 'rootReducer';
import {useDispatch, useSelector} from 'react-redux';
import PhoneInput from 'Shared/components/PhoneInput';
import withSelectedAgency, {WithSelectedAgencyProps} from 'Shared/components/withSelectedAgency';
import {saveMobilePhone} from 'Users/ducks/userAccount';
import { ANALYTICS_EVENT_ACTION } from 'Core/components/Analytics/AnalyticsEventConstants';

type UserEmailSectionProps = {
  userId: string;
  phoneEither: Either<PhoneNumber, PhoneNumber>;
  onChange: (phone: Async<Either<PhoneNumber, PhoneNumber>>) => void;
  saveMobilePhone: typeof saveMobilePhone;
} & WithSelectedAgencyProps;

const UserMobilePhoneSection = (props: UserEmailSectionProps) => {
  const dispatch = useDispatch();
  const {selectedAgency} = props;
  const mobilePhone = pipe(props.phoneEither, fold(identity, identity));
  const [originalMobilePhone] = useState(mobilePhone);
  const isEditing = isRight(props.phoneEither);
  const hasMobilePhoneChanged = !eqPhoneNumber.equals(originalMobilePhone, mobilePhone);
  const {analytics} = useSelector((state: ReducerState) => state.analytics);
  
  return (
    <Paper className="user-profile__user-info-section">
      <div className="user-info-section__header">
        <h3>Mobile Phone</h3>
      </div>
      <div className="user-info-section__name-fields">
        <PhoneInput
          className="user-info-section__profile-input"
          label="Mobile Phone"
          disabled={!isEditing}
          onChange={newMobilePhone => props.onChange(new Loaded(right(newMobilePhone)))}
          phoneNumber={mobilePhone}
        />
      </div>
      <div className="user-info-section__actions-container">
        {isEditing ? (
          <>
            <Button
              variant="contained"
              className="user-info-section__cancel-user-information-button"
              onClick={() => {
                props.onChange(new Loaded(left(originalMobilePhone)));
              }}
            >
              Cancel
            </Button>
            <Button
              disabled={!hasMobilePhoneChanged || !(mobilePhone instanceof ValidPhoneNumber)}
              color="primary"
              variant="contained"
              className="user-info-section__save-user-information-button"
              onClick={() =>
                props.saveMobilePhone(
                  dispatch,
                  props.userId,
                  mobilePhone as ValidPhoneNumber,
                  selectedAgency?.encryptedIdentifier
                )
              }
            >
              Save
            </Button>
          </>
        ) : (
          <Button
            className="user-info-section__edit-button"
            aria-label="Mobile Phone Information Edit"
            color="primary"
            variant="contained"
            onClick={() => {
              dispatch(changeAnalyticsState({page: analytics.page, ctaResponse: {eventAction: ANALYTICS_EVENT_ACTION.USER_PROFILE_EDITMOBILE}}))
              props.onChange(new Loaded(right(mobilePhone)))}}
          >
            Edit&nbsp;&nbsp;
            <i className="fa fa-edit" />
          </Button>
        )}
      </div>
    </Paper>
  );
};

export default withSelectedAgency(UserMobilePhoneSection);
